import React from "react";
import classes from "./outlineButton.module.scss";

const OutlineButton = (props) => {
  const {
    title = "",
    entry_fee = "",
    onClick = () => { },
    styles = {},
    icon = "",
    title0 = "",
    currency = "",
    currencyString ="",
  } = props || {};

  return (
    <button
      className={classes.__outline_button}
      onClick={onClick}
      style={styles}
    >
      {icon && <span className={classes.__outline_button_icon}>{icon}</span>}
      {
        title0 && (
          title0 
        )
      }
      {title}
      {
        currency && (
          currency === "$" ? "$" :
          <img style={{width:"auto", margin: "0 3px", order: currencyString==="PWRS" ? 2:1}}
            src={currency}
            alt=""
            height="15"
          />
        ) 
      }
      {entry_fee}
    </button >
  );
};

export default OutlineButton;
